import React from 'react';
import PickupDashboard from '../../../components/StoreModule/PickupDashboard/pickupdashboard.component';

export default class pickupdashboardScreen extends React.Component {
  render() {
    return (
      <div>
        <PickupDashboard></PickupDashboard>
      </div>
    )
  }
}
